import { LayerManagerV27 } from '@volkswagen-onehub/layer-manager';

import { useFeatureServices } from './use-feature-services';

export const useLayerManager = (): LayerManagerV27 | undefined => {
  return useFeatureServices()['layer-manager'];
};
